var render, staticRenderFns
import script from "./total_adjust_two.vue?vue&type=script&lang=js"
export * from "./total_adjust_two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520b7b66')) {
      api.createRecord('520b7b66', component.options)
    } else {
      api.reload('520b7b66', component.options)
    }
    
  }
}
component.options.__file = "found/views/fee/views/record_manage/discount_goods/form/total_adjust_two.vue"
export default component.exports